import React, { createContext, useContext } from 'react';
import { useSnackbar } from 'notistack';
import axiosInstance from "../configs/axiosConfig";
import { APIRouteConstants } from '../constants/routeConstants';

const StoreStatusContext = createContext();

export const StoreStatusProvider = ({ children }) => {
    const { enqueueSnackbar } = useSnackbar();

    const checkStoreStatus = async () => {
        try {
            // For now testing use dummy data as requested
            const res = await axiosInstance.get(APIRouteConstants.DASHBOARD.STORE_STATUS);
            const { data } = res;
            const isOnline = data.status;

            // const isOnline = false; // Set to false to test offline notification

            if (!isOnline) {
                enqueueSnackbar('The store is currently offline. Please try again later.', {
                    variant: 'error',
                    anchorOrigin: { vertical: 'top', horizontal: 'right' }
                });
                return false;
            }
            return true;
        } catch (err) {
            console.error("Error checking store status:", err);
            // In case of error, maybe allow proceeding or show a generic error
            return true;
        }
    };

    return (
        <StoreStatusContext.Provider value={{ checkStoreStatus }}>
            {children}
        </StoreStatusContext.Provider>
    );
};

export const useStoreStatus = () => {
    const context = useContext(StoreStatusContext);
    if (!context) {
        throw new Error('useStoreStatus must be used within a StoreStatusProvider');
    }
    return context;
};
